import { SubRoutes } from './constants';

export const getPath = (
  route: SubRoutes,
  routesInFlow: SubRoutes[],
  parentPath: string,
) => {
  const isFirst = routesInFlow[0] === route;

  return `${parentPath}/${isFirst ? '' : route}`;
};

export const isLastRoute = (route: SubRoutes, routesInFlow: SubRoutes[]) => {
  const lastRoute = routesInFlow[routesInFlow.length - 1];

  return lastRoute === route;
};

export const redirectIfNotInitialPath = ({
  pathname,
  parentPath,
  search,
}: {
  pathname: string;
  parentPath: string;
  search: string;
}) => {
  const isInitialEntryPoint = pathname === parentPath;

  if (!isInitialEntryPoint) {
    window.location.assign(`${parentPath}${search}`);
  }
};
